import { type ReactNode } from 'react';
import logoIcon from '@/assets/logo-icon.svg';
import { GlowOrb } from '@/components/effects/glow-orb';
import { LoginForm } from './login-form';

function LoginBranding(): ReactNode {
  return (
    <div className="mb-lg text-center sm:mb-xl">
      <img src={logoIcon} alt="Debook" className="mx-auto mb-md h-10 w-10" />
      <h1 className="font-display text-base font-medium tracking-tight text-text-primary">
        Debook
      </h1>
      <p className="mt-xs text-lg font-bold tracking-tight text-brand-red">
        The 3333 Games
      </p>
    </div>
  );
}

export function LoginPage(): ReactNode {
  return (
    <div className="relative flex min-h-dvh items-center justify-center bg-void px-base">
      <GlowOrb />
      <div className="relative z-10 w-full max-w-[300px]">
        <LoginBranding />
        <LoginForm />
      </div>
    </div>
  );
}
